// import React, { useEffect, useRef, useState } from "react";
// import loaderVideo from "../assets/load.mp4";
// import "./LogoLoader.css";

// const LogoLoader = () => {
//   const videoRef = useRef(null);
//   const [showSoundPrompt, setShowSoundPrompt] = useState(false);

//   useEffect(() => {
//     let isMounted = true;
//     const video = videoRef.current;
//     if (!video) return undefined;

//     const startPlayback = async () => {
//       video.muted = false;
//       try {
//         await video.play();
//         if (isMounted) {
//           setShowSoundPrompt(false);
//         }
//       } catch {
//         video.muted = true;
//         try {
//           await video.play();
//         } catch {
//         }
//         if (isMounted) {
//           setShowSoundPrompt(true);
//         }
//       }
//     };

//     startPlayback();

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   const handleEnableSound = async () => {
//     const video = videoRef.current;
//     if (!video) return;

//     video.muted = false;
//     try {
//       await video.play();
//       setShowSoundPrompt(false);
//     } catch {
//       video.muted = true;
//       setShowSoundPrompt(true);
//     }
//   };

//   return (
//     <div className="logo-loader" role="status" aria-live="polite" aria-label="Loading">
//       <video
//         ref={videoRef}
//         className="logo-loader-video"
//         autoPlay
//         muted
//         playsInline
//         preload="auto"
//         aria-hidden="true"
//       >
//         <source src={loaderVideo} type="video/mp4" />
//       </video>
//       {showSoundPrompt && (
//         <button type="button" className="logo-loader-sound-btn" onClick={handleEnableSound}>
//           Tap for sound
//         </button>
//       )}
//     </div>
//   );
// };

// export default LogoLoader;


import React from "react";
import logo from "../assets/logo.png";
import "./LogoLoader.css";

const LogoLoader = () => {
  return (
    <div className="logo-loader" role="status" aria-live="polite" aria-label="Loading">
      <div className="logo-loader-inner">
        <div className="logo-loader-ring" />
        <img src={logo} alt="Rung Do" className="logo-loader-img" />
      </div>
    </div>
  );
};

export default LogoLoader;
